import i18n from '@/lang';
/* unplugin-vue-components disabled */
import { Empty as __unplugin_components_3 } from 'vant/es';
import 'vant/es/empty/style/index';
import { SidebarItem as __unplugin_components_2 } from 'vant/es';
import 'vant/es/sidebar-item/style/index';
import { Sidebar as __unplugin_components_1 } from 'vant/es';
import 'vant/es/sidebar/style/index';
import { Search as __unplugin_components_0 } from 'vant/es';
import 'vant/es/search/style/index';
var render = function () {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c('div', {
    staticClass: "classification"
  }, [_c('div', {
    staticClass: "search"
  }, [_c(__unplugin_components_0, {
    attrs: {
      "shape": "round",
      "placeholder": i18n.tc("274")
    },
    on: {
      "search": _vm.getData
    },
    model: {
      value: _vm.seachForm.keyword,
      callback: function ($$v) {
        _vm.$set(_vm.seachForm, "keyword", $$v);
      },
      expression: "seachForm.keyword"
    }
  })], 1), _c('div', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "left"
  }, [_c('div', {
    staticClass: "sideNavigation"
  }, [_c(__unplugin_components_1, {
    on: {
      "change": _vm.onChange
    },
    model: {
      value: _vm.active,
      callback: function ($$v) {
        _vm.active = $$v;
      },
      expression: "active"
    }
  }, _vm._l(_vm.sidebarData, function (item, index) {
    return _c(__unplugin_components_2, {
      key: index,
      attrs: {
        "title": item.classification_name
      }
    });
  }), 1)], 1)]), _c('div', {
    staticClass: "right"
  }, [_c('div', {
    staticClass: "card"
  }, [_c('h1', [_vm._v(_vm._s(_vm.title))]), _c('div', {
    staticClass: "right-content"
  }, [_vm._l(_vm.classificationData, function (item, index) {
    return _c('div', {
      key: index,
      staticClass: "box",
      on: {
        "click": function ($event) {
          return _vm.goClassificationList(item);
        }
      }
    }, [_c('div', {
      staticClass: "img_box"
    }, [_c('img', {
      directives: [{
        name: "lazy",
        rawName: "v-lazy",
        value: item.classification_image || require('@/assets/icon/loading.png'),
        expression: "item.classification_image || require('@/assets/icon/loading.png')"
      }],
      attrs: {
        "alt": "img"
      }
    })]), _c('p', [_vm._v(_vm._s(item.classification_name))])]);
  }), !_vm.classificationData.length ? _c(__unplugin_components_3, {
    staticStyle: {
      "margin": "auto"
    }
  }) : _vm._e()], 2)])])])]);
};
var staticRenderFns = [];
export { render, staticRenderFns };